module.exports = __webpack_public_path__ + "img/output-1.ffff545e.png";